import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-performance-goal-report',
    templateUrl: './goals-report.component.html',
    styleUrls: ['./goals-report.component.scss']
})
export class GoalsReportComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
